const en = {
  check_out_with_prefix: ' Check out with ',
  check_out_with_suffix: ' ',

  Enter_Card_Number_Manually: 'Enter Card Number Manually',
  payment_method_title: 'Payment Method',
  add_your_card_here_title: 'Add Your Card Here',
  change_payment_method_title: 'Change Payment Method',
  confirm_and_pay_button: `Confirm & Pay • \${paymentAmount}`,
  confirm_and_pay_button_no_card: `Continue to Payment • \${paymentAmount}`,

  add_new_card: 'Add a Card',
  cancel_button: 'Cancel',
  done_button: 'Done',
  balance_amount: 'Balance:${paymentAmount}'
}

export default en
